<template>
  <div class="row">
    <div class="col-lg-12 col-xs-12">
      <b-card>
        <b-card-body>
          <div class="row">
            <div class="col-lg-10 col-xs-12">
              <h6 class="card-title mt-0">{{$t('views.exsbvindicationevents.index.showSummaryData')}}</h6>
              <template v-if="items.length > 0 && totalSums && totalSums.length > 0">
                <span>{{$t('views.exsbvindicationevents.index.sumCashDebt')}}: <b>{{ totalSums[0].sumToPay }} {{$t('currency')}}</b></span><br>
                <span>{{$t('views.exsbvindicationevents.index.sumInvoicesDebt')}}: <b>{{totalItems}}</b></span><br>
                <selectedInvoicesSum :for-vindication="true" :selected-invoices="selectedInvoices" />
              </template>
            </div>
            <div class="col-lg-2 col-xs-12">
              <button type="button" class="btn btn-primary btn-block" @click="generateVindicationEventsFromPeriodicMessages()"><i class="mr-1 fa fa-file"></i> {{$t('views.exsbvindicationevents.index.generateVindicationEventsFromPeriodicMessages')}}</button>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
    <div class="col-lg-12 col-xs-12">
      <b-tabs content-class="" nav-class="ml-1">
        <b-tab no-body :title="$t('views.exsbvindicationevents.index.showall')">
          <BaseTableWrapper>
            <template #filtering>
              <div class="text-right">
                <b-button v-if="filterStatus" variant="danger" class="btn-sm" v-b-tooltip.hover :title="$t('buttons.clearFilters')" @click="clearFilters"><i class="fa fa-sync"></i><span>{{$t('global.filtersAreSet')}}</span></b-button>
                <b-button aria-controls="invoice_search_collapse" class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.invoice_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
              </div>
              <div>
                <b-collapse id="invoice_search_collapse" class="mt-2">
                  <InvoiceFiltering
                    :filters="$store.state.filters.invoiceVindicationFilter"
                    :filterReference="$store.state.filters.invoiceVindicationReference"
                    :currentPageProp="$store.state.filters.invoiceVindicationCurrentPage"
                    :periodDateProp="$store.state.filters.invoiceVindicationPeriodDate"
                    :dateTypeProp="$store.state.filters.invoiceVindicationDateType"
                    @currentPageChange="$store.state.filters.invoiceVindicationCurrentPage = $event"
                    @periodDateChange="$store.state.filters.invoiceVindicationPeriodDate = $event"
                    @dateTypeChange="$store.state.filters.invoiceVindicationDateType = $event"
                    @getPage="getPage($event)" ref="invoiceVindicationFiltering"></InvoiceFiltering>
                </b-collapse>
              </div>
            </template>
            <template #body>
              <b-row>
                <b-col>
                  <div v-if="isLoading">
                    <Loader></Loader>
                  </div>
                  <div v-else-if="!isLoading && items.length < 1">
                    {{ $t('views.exsbinvoices.list.noInvoices') }}
                  </div>
                  <div v-else>
                    <table class="table table-sm table-responsive-md table-striped table-hover">
                      <thead>
                      <tr>
                        <th>
                          <b-form-checkbox @change="toggleSelectCurrentPage()" :checked="checkboxSelectAllStatus"  :indeterminate="checkboxSelectIndeterminateStatus"></b-form-checkbox>
                        </th>
                        <th>{{ $t('views.exsbinvoices.form.number') }}</th>
                        <th>{{ $t('views.exsbinvoices.list.type') }}</th>
                        <th>{{ $t('views.exsbinvoices.list.buyer') }}</th>
                        <th>{{ $t('views.appconfiguration.invoiceConfiguration.invoiceComment') }}</th>
                        <th>{{ $t('views.exsbinvoices.list.paymentDeadline') }}</th>
                        <th>{{ $t('views.exsbinvoices.list.toPay') }}</th>
                        <th colspan="2" />
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in items" :key="item['@id']">
                        <td>
                          <div style="margin: 0 auto; display: table;">
                            <b-form-checkbox
                              v-model="selectedInvoices"
                              :value="item"
                            ></b-form-checkbox>
                          </div>
                        </td>
                        <td>
                          <router-link
                            :to="{name: 'EXSBInvoiceShow', params: { id: item['@id'] }}"
                            v-b-tooltip.hover :title="$t('buttons.goto')" aria-hidden="true">{{item.number || $t('views.agreements.list.noNumber')}}
                          </router-link>
                          <b-badge v-if="item.sent === 1" style="cursor:pointer;" variant="success">
                            {{ $t('views.exsbinvoices.list.sent') }}
                          </b-badge>
                          <span v-if="item.invoiceCorrectionOf">
                          <br>
                          <small>
                            <router-link :to="{name: 'EXSBInvoiceShow', params: { id: item.invoiceCorrectionOf['@id'] }}">
                              <span class="text-danger">
                                {{ $t('views.exsbinvoices.form.corOf') }} {{ item.invoiceCorrectionOf.number }}
                              </span>
                            </router-link>
                          </small>
                        </span>
                        <span v-if="item.correctionId">
                          <br>
                          <small>
                            <router-link :to="{name: 'EXSBInvoiceShow', params: { id: '/core/public/index.php/api/e_x_s_b_invoices/' + item.correctionId }}">
                              <span class="text-danger">
                                {{ $t('views.exsbinvoices.form.corection') }} {{ item.correctionNumber }}
                              </span>
                            </router-link>
                          </small>
                        </span>
                        </td>
                        <td>
                          <p class="m-0" v-if="item.correctionOf && item.invoiceType && item.invoiceType.id === 1">{{ $t('views.exsb.vat_invoices.form.corOfTypeWithVat') }}</p>
                          <p class="m-0" v-else-if="item.correctionOf && item.invoiceType && item.invoiceType.id === 2">{{ $t('views.exsb.vat_invoices.form.corOfTypeNoVat') }}</p>
                          <p class="m-0" v-else>{{ item.invoiceType.name }}</p>
                          <b-badge v-if="item.cancellation === 1" style="cursor:pointer;" variant="danger">
                            {{ $t('views.exsb.vat_invoices.show.invoiceCancellation') }} <br>
                            {{ $t('views.exsb.vat_invoices.show.invoiceCancellationBy') }} {{item.cancellationByUser}} <br>
                            {{ $t('views.exsb.vat_invoices.show.invoiceCancellationDate') }} {{$moment(item.cancellationDate).format('YYYY-MM-DD')}}
                          </b-badge>
                        </td>
                        <td>
                          <router-link :to="{name: 'FirmShow', params: { id: item.idUserData['@id'] }}">
                            <div>{{ item.buyerName }}</div>
                          </router-link>
                          <router-link v-if="item.idAgreement" :to="{name: 'EXABAgreementShow', params: {id: item.idAgreement['@id']}}"><b-badge>{{ $t('views.excmdevice.show.clientSection.deviceAgreement.moveToAgreement') }}</b-badge></router-link>
                        </td>
                        <td>
                          <i v-if="item.comments" class="fa fa-eye fa-lg ml-4" :id="'invoice_info' + item['@id']"></i>
                          <b-popover custom-class="box-shadow shadow-sm bg-white rounded"
                                     triggers="hover" placement="top" variant="secondary" :target="'invoice_info' + item['@id']">
                            <span>{{item.comments}}</span>
                          </b-popover>
                        </td>
                        <td>
                          {{ $moment(item['paymentDeadline']).format('YYYY-MM-DD') }}
                        </td>
                        <td>
                          <div v-if="item.invoiceStatus && getIdLink(item.invoiceStatus['@id']) === '1'"><span class="text-danger">{{ $t('global.noPayment') }}<br>({{ item.toPay.toFixed(2) }} {{$t('currency')}})</span></div>
                          <div v-if="item.invoiceStatus && getIdLink(item.invoiceStatus['@id']) === '2'"><span class="text-success">{{ $t('global.paymentFull') }}<br>({{ item.toPay.toFixed(2) }} {{$t('currency')}})</span></div>
                          <div v-if="item.invoiceStatus && getIdLink(item.invoiceStatus['@id']) === '3'"><span class="text-warning">{{ $t('global.paymentPartial') }}<br>({{ item.toPay.toFixed(2) }} {{$t('currency')}})</span></div>
                          <b-badge v-if="item.idReceipt" variant="danger">
                            {{ $t('global.documentHasReceipt') }}
                          </b-badge>
                        </td>
                        <td>
                          <b-dropdown variant="link" size="sm" right text="Right align">
                            <template #button-content>
                              <i class="fa fa-bars fa-lg"></i>
                            </template>
                            <b-dropdown-item @click="editSingle(item['@id'])"><i class="fa fa-edit"></i> {{$t('buttons.edit')}}</b-dropdown-item>
                            <b-dropdown-item @click="generateInvoiceFromAgreementAgain(item)"><i class="fa fa-calculator"></i> {{$t('views.agreements.list.options.generateInvoiceFromAgreementAgain')}}</b-dropdown-item>
                            <b-dropdown-item @click="deleteSingle(item['@id'])"><i class="fa fa-trash"></i> {{$t('buttons.delete')}}</b-dropdown-item>
                          </b-dropdown>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="view">
                    <pagination :view="view" :totalItems="totalItems" @getPage="getPage($event)" @getPageNumber="setCurrentPage($event.page)"></pagination>
                  </div>
                  <button type="button" class="btn btn-sm btn-warning float-left" @click="selectAll()"> {{ $t('buttons.selectAll') }} </button>
                  <button type="button" class="btn btn-sm btn-warning float-left" @click="unSelectAll()"> {{ $t('buttons.unSelectAll') }} </button>
                  <b-dropdown size="sm" variant="warning" dropright text="Drop-Right">
                    <template #button-content>
                      {{ $t('buttons.collectionOperations') }}
                    </template>
                    <b-dropdown-item @click="showModalToSendVindicationEvents"><i class="fa fa-file-check mr-2"></i>{{$t('views.exsbinvoices.list.sendVindicationEvents')}}</b-dropdown-item>
                  </b-dropdown>
                </b-col>
                <GenerateInvoicesFromAgreementModal :regenerate="1" :id-collection="selectedAgreements"></GenerateInvoicesFromAgreementModal>
                <b-modal size="lg" ref="modalToSendVindicationEvents" hide-footer>
                  <div slot="modal-header">
                    <h6 class="modal-title m-0 float-left">
                      {{$t('views.exsbinvoices.list.sendVindicationEvents')}}
                    </h6>
                    <button type="button" aria-label="Close" class="close" @click="hideModalToSendVindicationEvents()">
                      ×
                    </button>
                  </div>
                  <b-row>
                    <b-col cols="12">
                      <b-form-group>
                        <label>{{$t('views.exsbinvoices.form.sentDate')}}:</label>
                        <VueCtkDateTimePicker no-header
                                              :label="$t('views.exsbinvoices.form.sentDate')"
                                              v-model="sentDate"
                                              format="YYYY-MM-DD HH:mm"
                                              :onlyDate="false"
                                              :right="true"
                                              formatted="YYYY-MM-DD HH:mm"
                        >
                        </VueCtkDateTimePicker>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <label>{{$t("global.messageType")}}:</label>
                      <b-form-group>
                        <b-form-radio-group buttons button-variant="outline-primary" id="monthlyInvoice" v-model="messageType" name="monthlyInvoice">
                          <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.exsbvindicationevents.index.eventTypeOne')}}</b-form-radio>
                          <b-form-radio button-variant="outline-primary" :value="2">{{$t('views.exsbvindicationevents.index.eventTypeTwo')}}</b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <div class="text-right">
                        <b-button aria-controls="legend_collapse" class="btn-sm ml-2" v-b-toggle.legend_collapse variant="primary">{{$t('views.excmnotificationmessage.legend.legend')}}</b-button>
                      </div>
                      <b-collapse id="legend_collapse" class="mt-2">
                        <content-field-invoices-legend></content-field-invoices-legend>
                      </b-collapse>
                    </b-col>
                    <template v-if="messageType === 1">
                      <b-col cols="12">
                        <b-form-group>
                          <label for="custom_email_content">{{ $t('views.excmnotificationmessage.form.mailTitle') }}:</label>
                          <input id="invoiceMailTitle" v-model="invoiceSettings.invoiceVindicationMailTitle" :class="['form-control']" type="text" placeholder="" >
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group>
                          <label for="custom_email_content">{{ $t('views.externalform.form.emailContent') }}:</label>
                          <trumbowyg ref="editor" v-model="invoiceSettings.customVindicationEmail" :config="trumbowygConfig" class="form-control" name="htmlContent">
                          </trumbowyg>
                        </b-form-group>
                      </b-col>
                    </template>
                    <b-col cols="12" v-else>
                      <b-form-group>
                        <label for="custom_email_content">{{ $t('views.externalform.form.emailContent') }}:</label>
                        <input id="customSmsContent" v-model="invoiceSettings.customVindicationSms" :class="['form-control']" type="text" placeholder="">
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col>
                      <button @click="sendVindicationEvents" class="btn btn-primary">{{ $t('buttons.send') }}</button>
                      <b-btn @click="hideModalToSendVindicationEvents" variant="danger">{{ $t('buttons.close') }}</b-btn>
                    </b-col>
                  </b-row>
                </b-modal>
              </b-row>
            </template>
          </BaseTableWrapper>
        </b-tab>
        <b-tab no-body :title="$t('views.exsbvindicationevents.index.vindicationEvents')">
          <BaseTableWrapper>
            <template #body>
              <b-row>
                <b-col>
                  <div v-if="isLoadingVindicationEvents">
                    <Loader></Loader>
                  </div>
                  <div v-else-if="!isLoadingVindicationEvents && vindicationEvents.length < 1">
                    {{ $t('views.exsbinvoices.list.noInvoices') }}
                  </div>
                  <div v-else>
                    <table class="table table-sm table-responsive-md table-striped table-hover">
                      <thead>
                      <tr>
                        <th>{{ $t('views.exsbvindicationevents.index.eventDate') }}</th>
                        <th>{{ $t('views.exsbdocument.list.invoiceNumber') }}</th>
                        <th>{{ $t('views.exsbvindicationevents.index.eventBalanceValue') }}</th>
                        <th>{{ $t('views.exsbvindicationevents.index.eventType') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in vindicationEvents" :key="item['@id']">
                        <td>{{item.eventDate}}</td>
                        <td>
                          <router-link
                            :to="{name: 'EXSBInvoiceShow', params: { id: item.idInvoice['@id'] }}"
                            v-b-tooltip.hover :title="$t('buttons.goto')" aria-hidden="true">{{item.invoiceNumber}}
                          </router-link>
                        </td>
                        <td>{{item.balanceValue}}</td>
                        <td>{{item.eventType}}</td>
                      </tr>
                      </tbody>
                    </table>
                    <div v-if="vindicationEventsView">
                      <pagination :view="vindicationEventsView" :totalItems="vindicationEventsTotalItems" @getPage="fetchVindicationEvents($event)"></pagination>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </template>
          </BaseTableWrapper>
        </b-tab>
        <b-tab no-body :title="$t('views.exsbvindicationevents.index.vindicationMessages')">
          <BaseTableWrapper>
            <template #filtering>
              <div class="text-right">
                <b-button aria-controls="message_search_collapse" class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.message_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
              </div>
              <div>
                <b-collapse id="message_search_collapse" class="mt-2">
                  <MessageFiltering @getPage="fetchVindicationMessages($event)"></MessageFiltering>
                </b-collapse>
              </div>
            </template>
            <template #body>
              <b-row>
                <b-col>
                  <div v-if="isLoadingVindicationMessages">
                    <Loader></Loader>
                  </div>
                  <div v-else-if="!isLoadingVindicationMessages && vindicationMessages.length < 1">
                    {{ $t('views.excmmessages.list.noMessages') }}
                  </div>
                  <div v-else>
                    <table class="table table-sm table-responsive-md table-striped table-hover">
                      <thead>
                      <tr>
                        <th>{{ $t('views.excmmessages.list.messageType') }}</th>
                        <th>{{ $t('views.excmmessages.list.createdAt') }}</th>
                        <th>{{ $t('views.excmmessages.list.plannedSending') }}</th>
                        <th>{{ $t('views.excmmessages.list.sender') }}</th>
                        <th>{{ $t('views.excmmessages.list.recipient') }}</th>
                        <th>{{ $t('views.excmmessages.list.recipientCc') }}</th>
                        <th>{{ $t('views.excmmessages.list.subject') }}</th>
                        <th>{{ $t('views.excmmessages.list.content') }}</th>
                        <th>{{ $t('views.excmmessages.list.status') }}</th>
                        <th>{{ $t('views.excmmessages.list.sentStatus') }}</th>
                        <th colspan="2" />
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in vindicationMessages" :key="item['@id']">
                        <td>
                          <i v-if="item.messageType === 1" class="ml-2 fa fa-envelope fa-lg"></i>
                          <i v-if="item.messageType === 2" class="ml-2 fa fa-sms fa-lg"></i>
                        </td>
                        <td>
                          {{ $moment(item['createdAt']).format('YYYY-MM-DD HH:mm:ss') }}
                        </td>
                        <td>
                          {{ $moment(item['plannedSending']).format('YYYY-MM-DD HH:mm:ss') }}
                        </td>
                        <td>
                          {{ item.sender }}
                        </td>
                        <td>
                          <div v-html="item.recipient.replace(/,/g, '<br>')"></div>
                          <p class="p-0 m-0" v-for="(userRecipient, userRecipientIndex) in item.recipientsUserData" :key="'userRecipientIndex' + userRecipientIndex">
                            <router-link v-if="userRecipient.isCompany === 0" :to="{name: 'UserDataShow', params: { id: userRecipient['@id'] }}">
                              {{ userRecipient.name }} {{ userRecipient.surname }}
                            </router-link>
                            <router-link v-else :to="{name: 'FirmShow', params: { id: userRecipient['@id'] }}">
                              {{ userRecipient.firmname1 === '' ? userRecipient.fullName : userRecipient.firmname1 }}
                            </router-link>
                          </p>
                        </td>
                        <td>
                          <div v-html="item.recipientCc.replace(/,/g, '<br>')"></div>
                        </td>
                        <td>
                          {{ item.subject }}
                        </td>
                        <td>
                          <span v-if="item.messageType === 1" class="text-primary" @click="showMessageModal(item)" style="cursor: pointer">{{$t('buttons.preview')}}</span>
                          <span v-if="item.messageType === 2 && item.contentSms">{{ item.contentSms.contentSms }}</span>
                        </td>
                        <td>
                          {{ item.sent }}
                        </td>
                        <td>
                          {{ item.sentStatus }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div v-if="vindicationMessagesView">
                      <pagination :view="vindicationMessagesView" :totalItems="vindicationMessagesTotalItems" @getPage="fetchVindicationMessages($event)"></pagination>
                    </div>
                    <b-modal ref="modalContentMail" hide-footer size="lg" centered>
                      <div v-html="modalContent.html">
                      </div>
                      <div v-if="modalContent.attachments.length > 0">
                        <hr>
                        <p><b>{{$t('views.messages.index.attachments')}}:</b></p>
                        <p v-for="attachment in modalContent.attachments" v-bind:key="attachment.id">{{attachment.fileName}}</p>
                        <p v-if="modalContent.attachments.length == 0">{{$t('views.messages.index.noAttachments')}}</p>
                      </div>
                    </b-modal>
                  </div>
                </b-col>
              </b-row>
            </template>
          </BaseTableWrapper>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../../Layout/Loader'
import Pagination from '../../../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import InvoiceFiltering from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/components/InvoiceFiltering'
import getId from '../../../../../../utils/getIdFromLink'
import remove from '@/utils/remove'
import GenerateInvoicesFromAgreementModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/GenerateinvoicesFromAgreementModal'
import addParamsToQuery from '@/utils/addParamsToQuery'
import ApiService from '@/utils/ApiService'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min'
import ContentFieldInvoicesLegend from '@/components/Dashboard/Views/Pages/AppConfiguration/components/contentFieldInvoicesLegend'
import SelectedInvoicesSum from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/components/SelectedInvoicesSum'
import MessageFiltering from '@/components/Dashboard/Views/excmmessage/components/MessageFiltering.vue'

export default {
  data () {
    return {
      invoiceSettings: {
        invoiceVindicationMailTitle: '',
        customVindicationEmail: '',
        customVindicationSms: ''
      },
      sentDate: '',
      invoiceMailTitle: '',
      customEmail: '',
      customSms: '',
      messageType: 1,
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btnsDef: {
          // Create a new dropdown
          image: {
            dropdown: ['insertImage'], /*, 'base64' */
            ico: 'insertImage'
          },
          insertText: {
            fn: () => this.insertText(),
            ico: 'blockquote'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['insertText']
        ],
        lang: this.$i18n.locale
      },
      modalContent: {
        html: '',
        attachments: []
      },
      searchParams: this.$store.state.filters.invoiceVindicationFilter,
      selectedInvoices: [],
      selectedAgreements: [],
      selectedItem: '',
      isLoadingVindicationEvents: true,
      vindicationEvents: [],
      vindicationEventsView: null,
      vindicationEventsTotalItems: 0,
      vindicationMessages: [],
      isLoadingVindicationMessages: true,
      vindicationMessagesView: null,
      vindicationMessagesTotalItems: 0
    }
  },
  components: {
    MessageFiltering,
    SelectedInvoicesSum,
    ContentFieldInvoicesLegend,
    GenerateInvoicesFromAgreementModal,
    Trumbowyg,
    VueCtkDateTimePicker,
    Loader,
    Pagination,
    BaseTableWrapper,
    InvoiceFiltering
  },

  props: {
    firmIRI: {
      type: String
    }
  },

  computed: {
    ...mapGetters({
      deletedItem: 'exsbinvoice/del/deleted',
      error: 'exsbinvoice/list/error',
      items: 'exsbinvoice/list/items',
      isLoading: 'exsbinvoice/list/isLoading',
      view: 'exsbinvoice/list/view',
      totalItems: 'exsbinvoice/list/totalItems',
      totalSums: 'exsbinvoice/list/totalSums'
    }),
    filterStatus () {
      return (
        (JSON.stringify(this.$store.state.filters.invoiceVindicationFilter) !== JSON.stringify(this.$store.state.filters.invoiceVindicationReference)) ||
        this.$store.state.filters.invoiceVindicationPeriodDate !== '' ||
        this.$store.state.filters.invoiceVindicationDateType !== 1
      )
    },
    checkboxSelectAllStatus () {
      // Sprawdzenie czy wszystkie elementy z items znajdują się w selectedInvoices. Kolejność nie ma znaczenia
      return this.items.every(item => this.selectedInvoices.includes(item))
    },
    checkboxSelectIndeterminateStatus () {
      if (this.checkboxSelectAllStatus) {
        return false
      }
      return this.items.some(item => this.selectedInvoices.includes(item))
    }
  },
  beforeCreate () {
    checkPagePermission('finances', 'EXSBInvoiceList')
    if (Object.keys(this.$store.state.filters.invoiceVindicationReference).length === 0) {
      this.$store.state.filters.invoiceVindicationReference = {
        number: '',
        buyerFilter: '',
        invoicePositionsFilter: '',
        invoiceType: '',
        invoiceStatus: '',
        correctionFilter: 4,
        order: 0,
        paymentWay: '',
        'paymentDeadline[after]': '',
        'paymentDeadline[before]': this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
        'issueDate[after]': '',
        'issueDate[before]': '',
        'sellDate[after]': '',
        'sellDate[before]': '',
        issuePlace: '',
        accepted: 1,
        comments: '',
        'toPay[gt]': 0,
        'idUserData.userDataTags.idTag': [],
        'idAgreement.agreementTags.tag': [],
        ksefStatusFilter: 0,
        hasDiscountFilter: ''
      }
    }
    if (Object.keys(this.$store.state.filters.invoiceVindicationFilter).length === 0) {
      this.$store.state.filters.invoiceVindicationFilter = JSON.parse(JSON.stringify(this.$store.state.filters.invoiceVindicationReference))
    }
  },

  watch: {
    accepted () {
      this.getList()
    }
  },

  created () {
    this.getList()
    this.channelBusinessInvoice = this.$store.state.Pusher.subscribe('e_x_s_b_invoices')
    this.channelBusinessInvoice.bind('e_x_s_b_invoices', data => {
      this.getList()
    })
    this.fetchVindicationEvents()
    this.fetchVindicationMessages()
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_invoices')
  },

  methods: {
    ...mapMutations({
      toggleGenerateInvoicesFromAgreementsModal: 'agreements/generateInvoicesFromAgreementModal/toggleModal'
    }),
    clearFilters () {
      if (this.$refs.invoiceVindicationFiltering) {
        this.$refs.invoiceVindicationFiltering.clearFilters()
      }
    },
    selectAll () {
      let selectAll = []
      for (let i in this.items) {
        selectAll.push(this.items[i])
      }
      this.selectedInvoices = selectAll
    },
    unSelectAll () {
      this.selectedInvoices = []
    },
    toggleSelectCurrentPage () {
      if (this.checkboxSelectAllStatus) {
        // Usuń wszystkie checkboxy z bieżącej strony
        this.selectedInvoices = this.selectedInvoices.filter(item => !this.items.includes(item))
      } else {
        // Dodaj brakujące elementy z bieżącej strony
        this.selectedInvoices = [...this.selectedInvoices, ...this.items.filter(item => !this.selectedInvoices.includes(item))]
      }
    },
    editSingle (id) {
      this.$router.push({ name: 'EXSBInvoiceUpdate', params: { id: id } })
    },
    deleteSingle (id) {
      remove(id, () => {
        this.getList()
      })
    },
    generateInvoiceFromAgreementAgain (item) {
      this.selectedAgreements = [getId(item.idAgreement)]
      this.toggleGenerateInvoicesFromAgreementsModal()
    },
    generateVindicationEventsFromPeriodicMessages () {
      this.$Swal({
        title: this.$t('notifications.invoice.generateVindicationEventsTitle'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(async () => {
        let response = await new ApiService(`e_x_s_b_invoices/generatevindicationeventsfromperiodicmessages`).post({})
        if (response) {
          this.reload()
        }
      })
    },
    getList () {
      let params = Object.assign({
        '_page': this.$store.state.filters.invoiceNotAcceptedCurrentPage,
        'order[issueDate]': 'desc',
        'order[numberValue]': 'desc',
        'order[batchNumber]': 'desc'
      }, this.searchParams)
      params.order = undefined
      let url = addParamsToQuery('e_x_s_b_invoices', params)
      this.getPage(url)
    },
    reload () {
      this.getPage(this.view['@id'])
      this.$emit('reload')
    },
    resetSelectedItems () {
      this.selectedInvoices = []
    },
    showModalToSendVindicationEvents () {
      this.getInvoiceSettings()
      this.$refs['modalToSendVindicationEvents'].show()
    },
    hideModalToSendVindicationEvents () {
      this.$refs['modalToSendVindicationEvents'].hide()
    },
    showMessageModal (mail) {
      this.modalContent.html = ''
      if (mail.contentEmail) {
        this.modalContent.html = mail.contentEmail
      } else if (mail.messageContentEmail && mail.messageContentEmail.contentEmail) {
        this.modalContent.html = mail.messageContentEmail.contentEmail
      }
      this.$refs.modalContentMail.show()
    },
    async fetchVindicationEvents (url = 'e_x_s_b_vindication_events') {
      this.isLoadingVindicationEvents = true
      let response = await new ApiService(url).getResults()
      this.vindicationEvents = response.items
      for (let i in this.vindicationEvents) {
        if (this.vindicationEvents[i].eventType === 1) {
          this.vindicationEvents[i].eventType = this.$t('views.exsbvindicationevents.index.eventTypeOne')
        } else if (this.vindicationEvents[i].eventType === 2) {
          this.vindicationEvents[i].eventType = this.$t('views.exsbvindicationevents.index.eventTypeTwo')
        }
        if (this.vindicationEvents[i].idInvoice.number === null || this.vindicationEvents[i].idInvoice.number === '') {
          this.vindicationEvents[i].invoiceNumber = this.$t('views.agreements.list.noNumber')
        } else {
          this.vindicationEvents[i].invoiceNumber = this.vindicationEvents[i].idInvoice.number
        }
        this.vindicationEvents[i].balanceValue = this.vindicationEvents[i].balanceValue + ' ' + this.$t('currency')
        if (this.vindicationEvents[i].eventDate) {
          this.vindicationEvents[i].eventDate = this.$moment(this.vindicationEvents[i].eventDate).format('YYYY-MM-DD HH:mm')
        } else {
          this.vindicationEvents[i].eventDate = ''
        }
      }
      this.vindicationEventsView = response.view
      this.vindicationEventsTotalItems = response.totalItems
      this.isLoadingVindicationEvents = false
    },
    async fetchVindicationMessages (url = 'e_x_c_m_messages') {
      this.isLoadingVindicationMessages = true
      let response = await new ApiService(url, { vindication: 1 }).getResults()
      this.vindicationMessages = response.items
      this.vindicationMessagesView = response.view
      this.vindicationMessagesTotalItems = response.totalItems
      this.isLoadingVindicationMessages = false
    },
    async sendVindicationEvents () {
      let selections = []
      for (let i in this.selectedInvoices) {
        selections.push(getId(this.selectedInvoices[i]['@id']))
      }
      let params = {
        selections: selections,
        sentDate: this.sentDate,
        messageTitle: this.invoiceSettings.invoiceVindicationMailTitle,
        messageContent: this.invoiceSettings.customVindicationEmail,
        messageType: this.messageType,
        messageContentSms: this.invoiceSettings.customVindicationSms
      }
      await new ApiService('e_x_s_b_invoices/vindicationeventssend').post(params)
      this.getList()
      this.fetchVindicationEvents()
      this.fetchVindicationMessages()
      this.$refs['modalToSendVindicationEvents'].hide()
      this.unSelectAll()
    },
    async getInvoiceSettings () {
      let owner = await new ApiService('owners/1').getResults()
      if (owner.invoiceSettings) {
        this.invoiceSettings = owner.invoiceSettings
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    ...mapActions({
      getPage: 'exsbinvoice/list/getItems'
    })
  }
}
</script>
